import { dailyRapSheetFixture } from './fixtures';
import type { DailyRapSheet, DailyRapSheetProvider } from './model';

export class FixtureDailyRapSheetProvider implements DailyRapSheetProvider {
  constructor(private readonly fixture: DailyRapSheet | null = dailyRapSheetFixture) {}

  async getDailyRapSheet(): Promise<DailyRapSheet | null> {
    return this.fixture;
  }
}

export const dailyRapSheetProvider: DailyRapSheetProvider = new FixtureDailyRapSheetProvider();
